import React from "react";
import "./CustomInput.scss";

const CustomInput = ({ type, value, onChange, placeholder }) => {
  return (
    <div className="custom-input">
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder=" " 
        autoComplete="off"
        required
      />
      <label>{placeholder}</label>
    </div>
  );
};

export default CustomInput;
